<template>
	<div class="hd-moa-frame-person-cup">
		<div class="hd-moa-frame-person-cup__human js-moa-frame-person-cup">
			<base-image-svg
				:source="require('!html-loader!../../assets/svgs/21-moa-frame-person.svg')"
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-person-cup {
		position: absolute;
		@include box(100%);
		display: flex;
		align-items: flex-end;

		&__human {
			width: 450px;

			:deep() svg {
				@include box(100%);

				#Human {
					@include fade-out();
					transform: translateY(20%);
				}

				#Calendar {
					@include fade-out();
					transform: translateX(10%);
				}
			}

			// Responsive
			@include res-screen-small {
				:deep() svg {
					max-height: 500px;
				}
			}
			@include res-screen-x-small {
				:deep() svg {
					max-height: 430px;
				}
			}

			@include res-screen-portrait {
				:deep() svg {
					max-height: 500px;
				}
			}
			
			@include res-screen-portrait-sm {
				:deep() svg {
					max-height: 300px;
				}
			}

			// Animation 
			&[data-state="animation-ready"] {
				:deep() svg {
					#Human {
						@include transition-frame-fade-in();
					}
					#Calendar {
						@include transition-frame-fade-in();
						transition-delay: 0.25s;
					}
				}
			}
		}

		@include res-screen-portrait {
			left: 20%;
		}

		@include res-screen-portrait-sm {
			left: 0%;
		}

	}
</style>